/* eslint-disable @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires */
const immutable = require('immutable/dist/immutable.js');

// Draft.js 0.11 expects the Immutable 3/4 behavior where converting a keyed
// collection to an array returns its values. Immutable 5 returns [key, value]
// entries instead, which makes Draft.js treat those tuples as ContentBlocks.
const mapPrototype = Object.getPrototypeOf(immutable.Map());

if (!Object.prototype.hasOwnProperty.call(mapPrototype, 'toArray')) {
  Object.defineProperty(mapPrototype, 'toArray', {
    configurable: true,
    writable: true,
    value() {
      return this.valueSeq().toArray();
    },
  });
}

module.exports = immutable;
